var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarred(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 404,
    height: 404,
    viewBox: "0 0 404 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M196.609 4.78864C197.368 -1.59621 206.632 -1.59621 207.391 4.78864L213.746 58.3518C221.953 127.516 276.484 182.047 345.648 190.254L399.211 196.609C405.596 197.368 405.596 206.632 399.211 207.391L345.648 213.746C276.484 221.953 221.953 276.484 213.746 345.648L207.391 399.211C206.632 405.596 197.368 405.596 196.609 399.211L190.254 345.648C182.047 276.484 127.516 221.953 58.3518 213.746L4.78864 207.391C-1.59621 206.632 -1.59621 197.368 4.78864 196.609L58.3518 190.254C127.516 182.047 182.047 127.516 190.254 58.3518L196.609 4.78864Z",
    fill: "#FBECCA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarred);
export default __webpack_public_path__ + "static/media/starred.659890b6a848911b2be8cbbefae39068.svg";
export { ForwardRef as ReactComponent };